import AnimalesTableFilters from './animales-table-filters';
export default AnimalesTableFilters;